<div class="iframe-shell">
    <iframe class="iframe" title="Model Navigator" src="https://asdmsimulator.cc/model_navigator" loading="lazy"
        referrerpolicy="no-referrer" allowfullscreen></iframe>
</div>